'use client';
import { jsx } from 'react/jsx-runtime';
import { I18nProvider } from '@react-aria/i18n';
import { useContext, useMemo } from 'react';
import { transformToLowercaseLocale } from '../../../core/constants/i18n.js';
import { SwanI18nContext } from './swan-i18n-provider.context.js';

const i18nFactory = (r, e)=>({
        getPluralKey: (t, o)=>{
            let n = new Intl.PluralRules(r).select(o), i = `${t}_${n}`;
            return e[i] ? i : e[`${t}_other`] ? `${t}_other` : t;
        },
        formatNumber: (e, t)=>new Intl.NumberFormat(r, t).format(e),
        formatDate: (e, t)=>new Intl.DateTimeFormat(r, t).format(e),
        t: (r, t)=>{
            if (!(r in e)) throw Error(`Missing entry for translation key '${r}'.`);
            return e[r].replace(/{{(\w+)}}/g, (e, o)=>{
                if (!t || !(o in t)) throw Error(`Missing placeholder for '${o}' in translation key '${r}'`);
                return t[o].toString();
            });
        }
    });
const SwanI18nProvider = (a)=>{
    let { translations: l, children: c } = a, m = useContext(SwanI18nContext), s = m ? m.locale : a.locale ? transformToLowercaseLocale(a.locale) : void 0;
    if (!s) throw Error('SwanI18nProvider requires a locale to be provided either via props or context.');
    let f = useMemo(()=>{
        let { getPluralKey: r, formatNumber: e, formatDate: t, t: o } = i18nFactory(s, l);
        return {
            locale: s,
            t: o,
            getPluralKey: r,
            formatNumber: e,
            formatDate: t
        };
    }, [
        s,
        l
    ]);
    return jsx(SwanI18nContext.Provider, {
        value: f,
        children: jsx(I18nProvider, {
            locale: s,
            children: c
        })
    });
};

export { SwanI18nProvider, i18nFactory };
